import myAiToolsPlugin from '@bayerit/backstage-plugin-my-ai-tools/alpha';
import { MyAiToolsPageContent } from '@bayerit/backstage-plugin-my-ai-tools';
import { FeatureFlagGate } from '@internal/plugin-feature-flags-common/components';
import { MY_AI_TOOLS_FEATURE_FLAG } from '@internal/plugin-feature-flags-common';

// Cast needed: published alpha types omit withOverrides/getExtension (same as
// other external alpha plugins in App.tsx).
const plugin = myAiToolsPlugin as any;

/**
 * Host page override: wrap the plain (non-routable) page in the runtime
 * feature flag. Do not nest the routable `MyAiToolsPage` export under the gate.
 */
const myAiToolsFeature = plugin.withOverrides({
  extensions: [
    plugin.getExtension('page:my-ai-tools').override({
      factory(originalFactory: (opts: { params: unknown }) => unknown) {
        return originalFactory({
          params: {
            path: '/my-ai-tools',
            noHeader: true,
            loader: async () => (
              <FeatureFlagGate flag={MY_AI_TOOLS_FEATURE_FLAG}>
                <MyAiToolsPageContent />
              </FeatureFlagGate>
            ),
          },
        });
      },
    }),
  ],
});

export default myAiToolsFeature;
